import { e } from "@interactivethings/swiss-federal-ci";
import { Shadows } from "@mui/material/styles/shadows";

export const shadows = e as Shadows;
